/**
 * Merge de los fragmentos de diccionario del admin.
 *
 * Cada fragmento exporta un objeto plano { 'texto español': { pt, en, ru } }.
 * Un texto repetido entre fragmentos debe tener la MISMA traducción (son
 * literales de UI globales tipo 'Guardar'/'Cancelar'); el merge posterior pisa
 * al anterior, así que el fragmento comunes.js va primero y los específicos
 * pueden especializar si alguna vez hiciera falta.
 */

import { DICCIONARIO_COMUNES } from './diccionario-comunes.js';
import { DICCIONARIO_NODOS } from './diccionario-nodos.js';
import { DICCIONARIO_MARKETING } from './diccionario-marketing.js';
import { DICCIONARIO_OPERACION } from './diccionario-operacion.js';
import { DICCIONARIO_MODALES } from './diccionario-modales.js';
import { DICCIONARIO_CONTRATO } from './diccionario-contrato.js';
import { DICCIONARIO_LOTOWHEEL } from './diccionario-lotowheel.js';
import { DICCIONARIO_LOTOWHEEL_EXTRA } from './diccionario-lotowheel-extra.js';
import { DICCIONARIO_SHELL } from './diccionario-shell.js';
import { DICCIONARIO_ADMINISTRACION } from './diccionario-administracion.js';
import { DICCIONARIO_PLATAFORMA } from './diccionario-plataforma.js';
import { DICCIONARIO_ESTADISTICAS } from './diccionario-estadisticas.js';
import { DICCIONARIO_WIZARD } from './diccionario-wizard.js';
import { DICCIONARIO_COMPONENTES } from './diccionario-componentes.js';
import { DICCIONARIO_VISTAS } from './diccionario-vistas.js';
import { DICCIONARIO_METADATA_MARKETING } from './diccionario-metadata-marketing.js';
import { DICCIONARIO_DIGI12 } from './diccionario-digi12.js';

export const TRADUCCIONES = {
    ...DICCIONARIO_COMUNES,
    ...DICCIONARIO_NODOS,
    ...DICCIONARIO_MARKETING,
    ...DICCIONARIO_OPERACION,
    ...DICCIONARIO_MODALES,
    ...DICCIONARIO_CONTRATO,
    ...DICCIONARIO_LOTOWHEEL,
    ...DICCIONARIO_LOTOWHEEL_EXTRA,
    ...DICCIONARIO_SHELL,
    ...DICCIONARIO_ADMINISTRACION,
    ...DICCIONARIO_PLATAFORMA,
    ...DICCIONARIO_ESTADISTICAS,
    ...DICCIONARIO_WIZARD,
    ...DICCIONARIO_COMPONENTES,
    ...DICCIONARIO_VISTAS,
    ...DICCIONARIO_METADATA_MARKETING,
    ...DICCIONARIO_DIGI12,
};
